import store from "@/store";

const localesAvaliable = {
    ptBr: {
        firstDayOfWeek: 1,
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje',
        clear: 'Limpar'
    }
}

export function getLocale(langIso = 'ptBr'){
    return localesAvaliable[langIso] == undefined ? {} : localesAvaliable[langIso];
}

export function getFormatByLanguage(){
    const schema = {
        en: 'yyyy/mm/dd',
        pt: 'dd/mm/yyyy',
        es: 'dd/mm/yyyy'
    }
    const myLang = store.getters.getUserLang;
    return schema[myLang] != undefined ? schema[myLang] : schema.en;
}

/**
 * Parses sent minutes into hours:minutes
 * @param {String|Integer} minutes
 * @param {Boolean} addText - to add hours or minutes at the end
 * @returns {String}
 */
export function minutesToTime(minutes = 0, addText = false) {
    try {
        minutes = parseInt(minutes, 10);

        if (isNaN(minutes) || minutes < 0) {
            return addText ? '0:00 minutos' : '0:00';
        }
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        const time = `${hours}:${remainingMinutes.toString().padStart(2, '0')}`;
        if (addText) {
            const roundedHours = parseInt(hours);
            return roundedHours > 0 ? roundedHours > 1 ? `${time} horas` : `${time} hora` : `${time} minutos`;
        }
        return time;
    } catch (error) {
        return addText ? '0:00 minutos' : '0:00';
    }
}